<div class="c-accordion__title u-m-bottom--sm" (click)="open = !open">
	<tvcore-icon *ngIf="!arrowTemplate" name="chevron" [class.rotated]="open"></tvcore-icon>
	<ng-container *ngTemplateOutlet="arrowTemplate"></ng-container>

	<p class="u-title-group u-m-left--xs flex--1">{{ title }}</p>

	<ng-container *ngTemplateOutlet="rightTemplate"></ng-container>
</div>

<div #accordionContent class="c-accordion__content" [class.c-accordion__content--pad]="leftPadding" [style.height]="open ? height : 0">
	<ng-content></ng-content>
</div>
